import { useEffect } from 'react';
import { useAppStore } from '../store';

export function Toast() {
  const toast = useAppStore((state) => state.toast);
  const setToast = useAppStore((state) => state.setToast);
  useEffect(() => { if (!toast) return; const timeout = window.setTimeout(() => setToast(null), 3_500); return () => window.clearTimeout(timeout); }, [toast, setToast]);
  return toast ? <div className="toast" role="status"><span>✓</span>{toast}<button onClick={() => setToast(null)} aria-label="Schließen">×</button></div> : null;
}
